import React, { useCallback, useRef, useState } from 'react';
import { DrawingId, drawings } from 'src/config/drawings';
import { mainVisual } from 'src/helpers/visuals';
import styles from './DrawingSVG.module.scss';
import cn from 'classnames';

interface DrawingSVGProps {
  onPathClick: (id: DrawingId) => void;
  history?: Array<DrawingId>;
}

export const DrawingSVG: React.VFC<DrawingSVGProps> = ({ onPathClick, history }) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [tooltipContent, setTooltipContent] = useState<string | null>(null);

  const handleOnClick = useCallback((id: DrawingId) => () => {
    onPathClick(id);
  }, [onPathClick]);

  const handleShowTooltip = useCallback((e: React.MouseEvent<SVGPathElement>) => {
    const { target } = e;
    const ref = tooltipRef.current;

    if (target instanceof SVGElement && ref) {
      if (!tooltipContent) setTooltipContent(target.dataset.title ?? '');
      ref.style.left = `${e.clientX - (ref.clientWidth / 2)}px`;
      ref.style.top = `${e.clientY - (ref.clientHeight + 8)}px`;
    }

  }, [tooltipContent]);

  const handleHideTooltip = useCallback(() => {
    setTooltipContent(null);
  }, []);

  return (
    <div className={styles['c-drawing-svg']}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 2560.7 1439.9"
        xmlSpace="preserve"
        className={styles['c-drawing-svg__tag']}
      >
        <image width="2560" height="1440" xlinkHref={mainVisual} transform="matrix(1 0 0 1 0.7244 -0.1102)" />
        {drawings.map(({ id, svgPath, title }) => {
          if (svgPath === null) return null;

          return (
            <circle
              key={id}
              data-title={title}
              role="button"
              tabIndex={0}
              cx={svgPath.cx}
              cy={svgPath.cy}
              r={46.5}
              className={cn(styles['c-drawing-svg__path'], {
                [styles['is-visited']]: history?.includes(id),
              })}
              onClick={handleOnClick(id)}
              onMouseMove={handleShowTooltip}
              onMouseLeave={handleHideTooltip}
            />
          );
        })}
      </svg>
      <div
        className={cn(styles['c-drawing-svg__tooltip'], {
          [styles['is-hidden']]: !tooltipContent,
        })}
        ref={tooltipRef}
      >
        {tooltipContent}
      </div>
      <div className={styles['c-drawing-svg__instruction']}>
        {/* eslint-disable-next-line max-len */}
          In ons interactieve collegeplan kun je zelf het schip besturen. Je navigeert door op de groene vakjes te klikken, waarmee je alle plekken aan boord kunt ontdekken. In elke afzonderlijke ruimte ontdek je weer iets nieuws. Houd je muis vast, beweeg hem van links naar rechts en laat je verrassen. Door op de groene icoontjes te klikken geef je nóg meer betekenis aan jouw reis.
      </div>
    </div>
  );
};
